import { baseApi } from './BaseService';
import type { RoleCatalog, RoleRoster, RoleAssignments, RoleEvents, PageQuery, ChangeRole } from '../responseTypes/platformRoles';
export const platformRolesApi = baseApi.injectEndpoints({
  endpoints: build => ({
    getPlatformRoleCatalog: build.query<RoleCatalog, void>({
      query: () => ({ url: 'admin/platform_roles' }),
      providesTags: ['PlatformRoles'],
    }),
    getPlatformRoleRoster: build.query<RoleRoster, PageQuery & { role?: string }>({
      query: params => ({ url: 'admin/platform_role_assignments', params }),
      providesTags: ['PlatformRoles'],
    }),
    getPlatformRoleAssignments: build.query<RoleAssignments, string>({
      query: userId => ({ url: 'admin/users/' + encodeURIComponent(userId) + '/platform_roles' }),
      providesTags: ['PlatformRoles'],
    }),
    grantPlatformRole: build.mutation<void, ChangeRole>({
      query: ({ userId, role, changeReason }) => ({
        url: 'admin/users/' + encodeURIComponent(userId) + '/platform_roles/' + encodeURIComponent(role),
        method: 'PUT', body: { changeReason },
      }),
    }),
    revokePlatformRole: build.mutation<void, ChangeRole>({
      query: ({ userId, role, changeReason }) => ({
        url: 'admin/users/' + encodeURIComponent(userId) + '/platform_roles/' + encodeURIComponent(role),
        method: 'DELETE', body: { changeReason },
      }),
    }),
    getPlatformRoleEvents: build.query<RoleEvents, PageQuery & { targetUserId?: string }>({
      query: params => ({ url: 'admin/platform_role_events', params }),
      providesTags: ['PlatformRoles'],
    }),
  }),
});
